/**
 * Hàm xử lý load thêm sản phẩm
 */
const loadItems = (button) => {
    // 1. Kiểm tra điều kiện dừng: đang load hoặc nút không tồn tại
    if (!button || button.classList.contains("loading")) return;

    const totalPages = parseInt($("[data-total-pages]").val());
    let currentPage = parseInt($("[data-current-page]").val());

    // Nếu đã hết trang thì xóa mốc load và dừng
    if (currentPage >= totalPages) {
        button.remove();
        return;
    }

    // 2. Thiết lập thông số cho trang tiếp theo
    currentPage++;
    const baseUrl = $("[data-next-url]").val();
    const nextUrl = baseUrl.replace(/page=[0-9]+/, "page=" + currentPage);
    
    // Cập nhật ngay input để đồng bộ logic tránh click/scroll bồi
    $("[data-current-page]").val(currentPage);

    // 3. Hiệu ứng loading
    button.classList.add("loading");

    // 4. Gọi AJAX lấy dữ liệu
    $.ajax({
        url: nextUrl,
        type: "GET",
        dataType: "html",
        success: function (responseHTML) {
            const newContent = $(responseHTML).find(".load-more-grid").html();
            if (newContent) {
                $(".load-more-grid").append(newContent);
            }

            // Fix an toàn cho color swatches nếu theme có dùng
            if (typeof colorSwatches === "function") {
                colorSwatches();
            }
        },
        error: function(err) {
            console.error("Lỗi AJAX load more:", err);
        },
        complete: function () {
            // Loại bỏ trạng thái loading
            button.classList.remove("loading");

            // Kiểm tra xem còn trang để load tiếp không
            if (currentPage >= totalPages) {
                button.remove();
            } else {
                // Cập nhật lại các input metadata để lần scroll tới hoạt động đúng
                const scollData = document.querySelector(".infinite-scroll__data");
                if (scollData) {
                    const nextUrlScroll = baseUrl.replace(/page=[0-9]+/, "page=" + (currentPage + 1));
                    const nextInput = scollData.querySelector("input[data-next-url]");
                    const curInput = scollData.querySelector("input[data-current-page]");
                    
                    if (nextInput) nextInput.value = nextUrlScroll;
                    if (curInput) curInput.value = currentPage;
                }
            }
        },
    });
};

/**
 * Hàm theo dõi vị trí cuộn chuột
 */
const initInfiniteScroll = () => {
    // Tìm phần tử làm mốc ở cuối danh sách sản phẩm (nút cũ hoặc spinner)
    const sentinel = document.querySelector(".js-load-more") || document.querySelector(".js-infinite-scroll");
    
    if (!sentinel) return;

    // Sử dụng một Observer duy nhất để tối ưu hiệu năng
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            // Khi người dùng cuộn đến phần tử mốc
            if (entry.isIntersecting) {
                loadItems(sentinel);
            }
        });
    }, {
        // Load trước khi chạm đáy 300px để trải nghiệm người dùng mượt hơn
        rootMargin: "300px", 
        threshold: 0.1
    });

    observer.observe(sentinel);
};

/**
 * Khởi tạo khi trang sẵn sàng
 */
(function () {
    // Nếu bạn vẫn muốn giữ khả năng click thủ công (nếu scroll chưa tới)
    document.querySelectorAll(".js-load-more").forEach((button) => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            loadItems(button);
        });
    });

    // Kích hoạt tự động load khi cuộn
    initInfiniteScroll();
})();